export default "__VITE_ASSET__BWHrWUum__"